<template>
    <div class="row mb-4" v-if="chartModes.length > 0">
        <div class="col">
            <b-card class="mb-4" >
                <template #header>
                    <div class="d-sm-flex justify-content-between align-items-center">
                        <div class="font-weight-bold mb-1 mb-sm-0">
                            Meu desempenho nos últimos 30 dias
                        </div>
                        <select class="form-select form-select-sm col-12 col-sm-6" v-model="actualMode">
                            <option :value="index" v-for="(chartMode, index) in chartModes" :key="chartMode.id">
                                {{ chartMode.name }}
                            </option>
                        </select>
                    </div>
                </template>

                <b-overlay :show="loading" rounded="sm" >
                    <div class="row mb-3">
                        <div class="col">
                            <div class="card">
                                <div class="card-body lh-sm">
                                    <div class="fs-4 font-weight-bold">
                                        {{ chartModes[actualMode]?.overview.average ?? '---' }}
                                    </div>
                                    <div>
                                        Média das Notas
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Note -->
                    <chart-count-essays  :chart-data="chartModes[actualMode]?.chartNotes"></chart-count-essays>
                </b-overlay>
            </b-card>
        </div>
    </div>
</template>

<script>
import ChartCountEssays from "./ChartCountEssays";
export default {
    components:{
        ChartCountEssays
    },
    data(){
        return {
            actualMode: null,
            loading: false,
            chartOverview: [],
            chartModes: [],
        }
    },
    created(){
        this.load()
    },
    methods: {
        load() {
            const today = new Date();
            const daysAgo = this.$moment(today).subtract(30, 'days');

            this.loading = true;
            axios.get('/student/reports/essays', {
                params: {
                    start_date: this.$moment(daysAgo).format('YYYY-MM-DD'),
                    end_date: this.$moment(today).format('YYYY-MM-DD'),

                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    this.chartOverview = response.chartOverview;
                    this.chartModes = response.chartModes;
                    if(this.chartModes.length> 0){
                        this.actualMode = 0;
                    }

                })
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style>

</style>
